(function(){
  function boot(){
    var root = document.querySelector('.solos-au-lp');
    if (!root || root.dataset.solosBooted) return;
    root.dataset.solosBooted = '1';

    /* ---------- Know More reveal ---------- */
    var btn = document.getElementById('solos-know-more-btn');
    if (btn) {
      btn.addEventListener('click', function(){
        var open = btn.getAttribute('data-open') === '1';
        var blocks = document.querySelectorAll('.hidden-more-content');
        for (var i = 0; i < blocks.length; i++) {
          blocks[i].classList.toggle('revealed', !open);
        }
        btn.setAttribute('data-open', open ? '0' : '1');
        btn.textContent = open ? 'Know More About Custom Socks Australia' : 'Show Less';
        if (open) btn.scrollIntoView({behavior:'smooth', block:'center'});
      });
    }



    /* ---------- Testimonials carousel ---------- */
    var REVIEWS = [
      {n:'Charlotte', l:'United Kingdom', q:"Great service and products. I've ordered a few times from Solos Socks and the ordering process is so smooth and they are very responsive when enquiring on delivery dates."},
      {n:'Michelle', l:'Australia', q:'Solos athletic socks are great quality, soft and very comfortable. They are also hard wearing and wash really well.'},
      {n:'Andy', l:'New Zealand', q:'Great quality, great service, great experience all around. The best socks I\u2019ve worn and received great feedback from everyone!'},
      {n:'Isaiah', l:'United States', q:'The customer service was unrivaled and the product was fantastic. 5/5!'},
      {n:'Jane', l:'Australia', q:'Wonderful Product and Service, happy client!'},
      {n:'Lucy', l:'United States', q:'I experienced great customer service! Their design team was easy to work with and they listened at every turn. Shipping was fast and on time!'},
      {n:'Volo', l:'Australia', q:'Absolutely lovely socks and great doing business with you for my promotional event!'}
    ];
    var ri = 5, timer = null;
    var elName = document.querySelector('[data-solos-name]'),
        elLoc  = document.querySelector('[data-solos-loc]'),
        elQuo  = document.querySelector('[data-solos-quote]'),
        dots   = document.querySelectorAll('[data-solos-dot]');

    function paint(){
      if (!elName) return;
      var r = REVIEWS[ri];
      elName.textContent = r.n;
      elLoc.textContent = r.l;
      elQuo.textContent = r.q;
      for (var i = 0; i < dots.length; i++) {
        dots[i].style.background = (i === ri) ? '#131513' : '#cfd2ce';
      }
    }
    function step(d){ ri = (ri + d + REVIEWS.length) % REVIEWS.length; paint(); }

    var rbtns = document.querySelectorAll('[data-solos-review]');
    for (var i = 0; i < rbtns.length; i++) {
      rbtns[i].addEventListener('click', function(){
        clearInterval(timer);
        step(parseInt(this.getAttribute('data-solos-review'), 10));
      });
    }
    if (elName) timer = setInterval(function(){ step(1); }, 5000);

    /* ---------- Choose Socks slider ---------- */
    var track = document.querySelector('[data-solos-track]');
    var si = 0, MAXI = 5; /* 8 cards, 3 visible */
    var sbtns = document.querySelectorAll('[data-solos-slide]');
    for (var j = 0; j < sbtns.length; j++) {
      sbtns[j].addEventListener('click', function(){
        if (!track) return;
        si = Math.min(MAXI, Math.max(0, si + parseInt(this.getAttribute('data-solos-slide'), 10)));
        track.style.transform = 'translateX(calc(-' + si + ' * (100% / 3 + 6px)))';
      });
    }


    /* ---------- Product card: thumbnail switches main image ---------- */
    var cards = document.querySelectorAll('.csa-card');
    for (var ci = 0; ci < cards.length; ci++) {
      (function(card){
        var main = card.querySelector('[data-csa-main]');
        var thumbs = card.querySelectorAll('[data-csa-thumb]');
        for (var ti = 0; ti < thumbs.length; ti++) {
          thumbs[ti].addEventListener('click', function(){
            if (!main) return;
            main.style.opacity = '0';
            var url = this.getAttribute('data-full');
            var pre = new Image();
            pre.onload = function(){ main.src = url; main.style.opacity = '1'; };
            pre.onerror = function(){ main.style.opacity = '1'; };
            pre.src = url;
            for (var k = 0; k < thumbs.length; k++) thumbs[k].classList.remove('is-on');
            this.classList.add('is-on');
          });
        }
      })(cards[ci]);
    }

    /* ---------- HubSpot form + UTM passthrough ---------- */
    var utms = {}, keys = ['utm_source','utm_medium','utm_campaign','utm_term','utm_content'];
    var qp = new URLSearchParams(window.location.search);
    keys.forEach(function(k){ utms[k] = qp.get(k) || ''; });

    window.addEventListener('message', function(event){
      var d = event.data;
      if (!d || d.type !== 'hsFormCallback' || d.eventName !== 'onFormSubmit') return;
      var combined = Object.assign({}, utms);
      (d.data || []).forEach(function(item){ combined[item.name] = item.value || ''; });
      var qs = new URLSearchParams(combined).toString();
      setTimeout(function(){
        window.location.href = 'https://www.solossocks.com/pages/thank-you?' + qs;
      }, 400);
    });


    var SOLOS_FORM_CSS = 'body,html{margin:0!important;padding:0!important;background:transparent!important}.hs-richtext,.hs_cos_wrapper_type_rich_text,form>p{display:none!important}form{font-family:Figtree,Helvetica,Arial,sans-serif!important}.hs-form-field{margin-bottom:8px!important}label{font-size:12px!important;font-weight:600!important;color:#3a3d3a!important;margin-bottom:3px!important;line-height:1.25!important;display:block!important}.hs-form-required{color:#c04a34!important}.hs-input{height:auto!important;min-height:0!important;padding:7px 10px!important;font-size:13.5px!important;line-height:1.35!important;border:1px solid #dcdcd7!important;border-radius:7px!important;background:#fdfdfc!important;box-sizing:border-box!important;width:100%!important}.hs-input:focus{outline:none!important;border-color:#3f7f68!important}textarea.hs-input{min-height:48px!important;height:48px!important;resize:vertical!important}fieldset{max-width:none!important;border:0!important;padding:0!important;margin:0!important}fieldset.form-columns-2 .hs-form-field{width:50%!important;float:left!important;box-sizing:border-box!important;padding-right:8px!important}fieldset.form-columns-2 .hs-form-field+.hs-form-field{padding-right:0!important;padding-left:8px!important}.input{margin-right:0!important}.hs-fieldtype-intl-phone .hs-input{width:100%!important}.hs_recaptcha{margin:4px 0 0!important;transform:scale(.8);transform-origin:left top;height:62px!important}.hs-button{background:#131513!important;color:#fff!important;border:0!important;border-radius:999px!important;padding:11px 38px!important;font:600 14px/1 Figtree,sans-serif!important;cursor:pointer!important;display:block!important;margin:2px auto 0!important;width:auto!important}.hs-button:hover{background:#3f7f68!important}.hs-error-msg,.hs-error-msgs label{color:#c04a34!important;font-size:11.5px!important;font-weight:500!important}.hs-fieldtype-file{font-size:12.5px!important}@media(max-height:900px){.hs-form-field{margin-bottom:6px!important}.hs-input{padding:6px 10px!important;font-size:13px!important}textarea.hs-input{min-height:42px!important;height:42px!important}}';

    function styleHsForm(form){
      try {
        var node = (form && form.length) ? form[0] : form;
        var doc = node && node.ownerDocument ? node.ownerDocument : document;
        if (doc.getElementById('solos-hs-style')) return;
        var st = doc.createElement('style');
        st.id = 'solos-hs-style';
        st.textContent = SOLOS_FORM_CSS;
        (doc.head || doc.documentElement).appendChild(st);
      } catch(e) {}
    }

    function mountHubspot(targetId){
      var target = document.getElementById(targetId);
      if (!target || target.dataset.hsMounted) return true;
      if (!(window.hbspt && window.hbspt.forms)) return false;
      target.dataset.hsMounted = '1';
      window.hbspt.forms.create({
        region: 'ap1',
        portalId: '442321890',
        formId: '872a7463-7fd3-4286-bba0-02bb2f291803',
        target: '#' + targetId,
        css: '',
        onFormReady: function(form){
          styleHsForm(form);
          try {
            var nf = form[0] || form;
            Object.keys(utms).forEach(function(f){
              var input = nf.querySelector('input[name="' + f + '"]');
              if (input) input.value = utms[f];
            });
          } catch(e) {}
        }
        ,onFormDefinitionFetchError: function(){}
      });
      window.addEventListener('message', function(ev){
        var d = ev.data;
        if (d && d.type === 'hsFormCallback' && d.eventName === 'onFormReady') {
          var fr = document.querySelectorAll('#' + targetId + ' iframe');
          for (var z = 0; z < fr.length; z++) {
            try { styleHsForm(fr[z].contentDocument.body); } catch(e) {}
          }
        }
      });
      return true;
    }

    (function waitHs(){
      if (mountHubspot('hubspot-form')) return;
      setTimeout(waitHs, 200);
    })();

    /* ---------- Request a Quote -> modal with the same form ---------- */
    var modal = document.getElementById('solos-quote-modal');
    if (modal) {
      var lastFocus = null;
      function openQuote(){
        lastFocus = document.activeElement;
        modal.hidden = false;
        document.body.style.overflow = 'hidden';
        (function tryMount(){
          if (!mountHubspot('hubspot-form-modal')) setTimeout(tryMount, 200);
        })();
        var c = modal.querySelector('.solos-modal__close');
        if (c) c.focus();
      }
      function closeQuote(){
        modal.hidden = true;
        document.body.style.overflow = '';
        if (lastFocus && lastFocus.focus) lastFocus.focus();
      }
      var openers = document.querySelectorAll('[data-solos-quote]');
      for (var qi = 0; qi < openers.length; qi++) {
        openers[qi].addEventListener('click', function(e){ e.preventDefault(); openQuote(); });
      }
      var closers = modal.querySelectorAll('[data-solos-quote-close]');
      for (var ci2 = 0; ci2 < closers.length; ci2++) {
        closers[ci2].addEventListener('click', closeQuote);
      }
      document.addEventListener('keydown', function(e){
        if (e.key === 'Escape' && !modal.hidden) closeQuote();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();